// @flow

import type {TourOperatorState} from 'redux/tourOperator/TourOperatorState';
import type {UiState} from 'redux/uiState/UiState';
import type {V1State} from 'redux/v1/V1State';

export type ApplicationRedux = {
  ui: UiState,
  v1: V1State,
  tourOperator: TourOperatorState,
};

export const uiState = (state: ApplicationRedux): UiState => state.ui;
export const v1State = (state: ApplicationRedux): V1State => state.v1;
export const tourOperatorState = (state: ApplicationRedux): TourOperatorState =>
  state.tourOperator;
